// src/services/Firebase.js
import { initializeApp } from 'firebase/app';
import { getAnalytics, isSupported } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyD0JhDTbzSMzFm3rJ7HiNMgVgwzEmVbVYA",
  authDomain: "pereodictablefree.firebaseapp.com",
  databaseURL: "https://pereodictablefree.firebaseio.com",
  projectId: "pereodictablefree",
  storageBucket: "pereodictablefree.appspot.com",
  messagingSenderId: "341642081163",
  appId: "1:341642081163:web:94f187af0c9b390e3f358e",
  measurementId: "G-1NLRQGGCVP"
};

export const app = initializeApp(firebaseConfig);

// analytics может быть недоступен (SSR, приватный режим, неподдерживаемый браузер),
// поэтому проверяем isSupported() и инициализируем асинхронно.
export let analytics = null;

// getAnalytics() загружает gtag.js (~150 КБ) — после загрузки страницы, когда браузер свободен,
// чтобы не отнимать сеть и процессор у первой отрисовки. Раньше — при первом действии пользователя
// или уходе со вкладки, чтобы не терять события коротких визитов. События до этого ждут analyticsReady.
const EARLY_EVENTS = ['pointerdown', 'keydown', 'scroll', 'visibilitychange'];
const afterPageLoad = () =>
  new Promise((resolve) => {
    const done = () => {
      EARLY_EVENTS.forEach((type) => document.removeEventListener(type, done, true));
      resolve();
    };
    EARLY_EVENTS.forEach((type) => document.addEventListener(type, done, { capture: true, passive: true }));
    const whenIdle = () =>
      window.requestIdleCallback ? window.requestIdleCallback(done, { timeout: 3000 }) : setTimeout(done, 1000);
    if (document.readyState === 'complete') {
      whenIdle();
    } else {
      window.addEventListener('load', whenIdle, { once: true });
    }
  });

export const analyticsReady = afterPageLoad()
  .then(() => isSupported())
  .then((supported) => {
    if (supported) {
      analytics = getAnalytics(app);
    } else {
      // eslint-disable-next-line no-console
      console.warn('[Analytics] не поддерживается в этом окружении');
    }
    return analytics;
  })
  .catch(() => null);